var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.zone._id)?_c('div',{class:['zone', _vm.zone.vertical ? 'vertical' : '', _vm.zone.available ? 'available' : ''],style:({
    left: _vm.zone.left + 'px',
    top: _vm.zone.top + 'px',
    color: 'white',
    fontSize: '10px',
  }),on:{"click":_vm.putDice}},[_c('div',{staticClass:"scroll-off wraper"},[_c('plane-zone-sides',{attrs:{"linkLines":_vm.linkLines,"sideList":_vm.zone.sideList,"position":{ left: _vm.zone.left, top: _vm.zone.top, vertical: _vm.zone.vertical }}}),_vm._l((Object.keys(_vm.zone.itemMap)),function(id){return _c('dice',{key:id,attrs:{"diceId":id}})})],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }